export default __webpack_public_path__ + "static/media/refresh-icon.c176c38a.svg";